import { Button, Flex, Dropdown, DropdownContainer, Text, Stack } from '@instamenu/ui-system-next';
import { useRef } from 'react';
import { useDisclosure } from '@instamenu/react-hooks';
import { CustomCameraCapture } from './custom-camera-capture';
import { NativeCameraCapture, supportsNativeCameraUI } from './native-camera-capture';
import { Camera, Paperclip, Plus } from 'lucide-react';
import * as styles from './camera-capture.css';
import { acceptedFileTypes } from '../../thread/attachment-utils';

export type CameraCaptureAttachment = {
  data: string;
  mimeType: string;
  name: string;
};

export type CameraCaptureProps = {
  disabled?: boolean;
  onCapture?: (attachment: CameraCaptureAttachment) => void;
};

export const CameraCapture = (props: CameraCaptureProps) => {
  const [cameraModalOpen, { open: openCameraModal, close: closeCameraModal }] =
    useDisclosure(false);
  const [menuOpen, { toggle: toggleMenu, close: closeMenu }] = useDisclosure(false);

  const inputRef = useRef<HTMLInputElement>(null);

  const isFileUploadSupported = !!(
    window.File &&
    window.FileReader &&
    window.FileList &&
    window.Blob
  );

  const handleAttachFile = () => {
    closeMenu();
    inputRef.current?.click();
  };

  const handleTakePhoto = () => {
    closeMenu();
    if (supportsNativeCameraUI()) {
      inputRef.current?.click();
    } else {
      openCameraModal();
    }
  };

  return (
    <Flex style={{ gap: 8 }}>
      <DropdownContainer
        onDismiss={() => {
          closeMenu();
        }}
      >
        <Button
          disabled={props.disabled}
          size="icon"
          onClick={() => {
            if (props.disabled) return;
            toggleMenu();
          }}
        >
          <Plus width={18} height={18} />
        </Button>
        <Dropdown visible={menuOpen} placement="above" align="left">
          <Stack>
            {isFileUploadSupported && (
              <Button
                type="button"
                className={styles.menuItem}
                onClick={handleAttachFile}
                disabled={props.disabled}
                containerStyle={{ gap: 4, alignItems: 'center' }}
              >
                <Paperclip width={18} height={18} />
                <Text>Attach file</Text>
              </Button>
            )}
            <Button
              type="button"
              className={styles.menuItem}
              onClick={handleTakePhoto}
              disabled={props.disabled}
              containerStyle={{ gap: 4, alignItems: 'center' }}
            >
              <Camera width={18} height={18} />
              <Text>Take Photo</Text>
            </Button>
          </Stack>
        </Dropdown>
      </DropdownContainer>
      <NativeCameraCapture
        inputRef={inputRef}
        onCapture={props.onCapture}
        accept={acceptedFileTypes}
      />

      <CustomCameraCapture
        opened={cameraModalOpen}
        onCapture={props.onCapture}
        onClose={closeCameraModal}
      />
    </Flex>
  );
};
